/** Mirrors backend `PartnerStatus` (src/constants/partner.constants.ts). */
export enum CustomerStatus {
  Active = 'active',
  Deleted = 'deleted',
}

/** Mirrors backend `PartnerProfileDocumentsStatus`. */
export enum CustomerProfileDocumentsStatus {
  NotSubmitted = 'not_submitted',
  WaitingForApproval = 'waiting_for_approval',
  Completed = 'completed',
  Expired = 'expired',
  Failed = 'failed',
}

/** Mirrors backend `ChargeProvider` (src/enums/billing.enum.ts). */
export enum CustomerChargeProvider {
  Stripe = 'stripe',
  Manual = 'manual',
}

export enum CustomersTableFields {
  logoUrl = 'logoUrl',
  displayName = 'displayName',
  masterContractorOnboardedAt = 'masterContractorOnboardedAt',
  profileDocumentsStatus = 'profileDocumentsStatus',
  createdAt = 'createdAt',
}

/** Mirrors backend `PartnerProductName` (src/enums/partner-product.enum.ts). */
export enum CustomerProductName {
  GigSafe = 'gigsafe',
  Payments = 'payments',
  Subcontractor = 'subcontractor',
  ApiIntegration = 'api_integration',
  McLite = 'mclite',
  Opportunities = 'opportunities',
}
